import React, {ReactElement, useState, useEffect} from 'react';
import ProductGrid from '../ProductGrid';
import {StoreProduct, Variant} from '../../models/storeProduct';
import {Color, Product} from '../../models/product';
import ProductListingCard from '../ProductsListingCard/index';
import {useStoreType} from '../../hooks';
import {StoreProductWithImage} from './index';

type StoreProductsListProps = {
  storeSlug: string;
  products: StoreProductWithImage[];
  mmsProducts: Product[];
  numCol: number;
};

export type StoreProductWithColors = StoreProductWithImage & {
  colors: Color[];
};

function getProductColors(
  storeProduct: StoreProduct,
  mmsProducts: Product[]
): Color[] {
  const enabledColorIds = storeProduct.variants
    .filter(v => v.enabled)
    .map(v => v.colorId);
  const mmsProduct = mmsProducts.find(p => p.id === storeProduct.styleId);
  if (mmsProduct)
    return enabledColorIds.map(colorId =>
      mmsProduct.colors.find(c => c.id === colorId)
    );
  return [];
}

const ProductList: React.FC<StoreProductsListProps> = ({
  storeSlug,
  products,
  mmsProducts,
  numCol
}: StoreProductsListProps): ReactElement => {
  const [productListState, setProductListState] = useState<
    StoreProductWithColors[]
  >([]);

  useEffect(() => {
    if (products && mmsProducts) {
      const data = products.map(item => {
        const colors = getProductColors(item, mmsProducts);
        return {...item, colors};
      });
      setProductListState(data);
    }
  }, [products, mmsProducts]);

  const handleSelectVariant = (id: number, colorId: number) => {
    function isColorIdMatch(variant: Variant) {
      return variant.colorId === colorId;
    }

    // possible refactor
    setProductListState((prv: StoreProductWithColors[]) => {
      const index = prv
        .map(item => {
          return item.id;
        })
        .indexOf(id);
      const data = prv;
      const foundImage =
        prv[index].variants.find(isColorIdMatch).primaryImageUrl;
      data[index].mainImage = foundImage;
      return [...data];
    });
  };

  const {isStoreTypeGroupOrder} = useStoreType();

  return (
    <div className="storeProductList">
      {productListState && (
        <ProductGrid.Container>
          {productListState.map(item => {
            const donationItem = item.detailsProvider === 'donation';
            return (
              <ProductGrid.Item
                numColLg={numCol}
                numColMd={isStoreTypeGroupOrder ? 1 : 2}
                gridKey={`${item.id}`}
                key={item.id}
                numColSm={1}>
                <ProductListingCard
                  storeSlug={storeSlug}
                  product={item}
                  handleSelect={handleSelectVariant}
                  donationItem={donationItem}
                />
              </ProductGrid.Item>
            );
          })}
        </ProductGrid.Container>
      )}
    </div>
  );
};

export default ProductList;
